/* eslint-disable consistent-return */
import React from 'react';
import { Image, Text, View } from '@applane/react-core-components';
import { getUser, invoke } from '../../../AppServices';
import { Toast } from '../../../app-components';
import { Form } from '../../../app-components/form/Form';
import { multiSearchInput } from '../../../autoSuggestions';
import { dangerLogo, rescheduleIcon } from '../../../images';
import {
  getUserRole,
  validateMaxMileage,
  validateMinMileage,
} from '../../../Lib/helpers';
import vars from '../../../theme/vars';
import { ROUTES } from '../../../Lib/constants';

const computationFunction = (data) => {
  const arr = [];
  for (let i = 0; i < data?.make?.length; i += 1) {
    for (let j = 0; j < data?.model?.length; j += 1) {
      if (data?.make[i]._id === data?.model[j]?.maker?._id) {
        arr.push(data?.model[j]);
      }
    }
  }
  return {
    set: { model: arr },
  };
};

const fromYearValidation = ({ data }) => {
  if (data?.carDetails === 'Any') {
    return;
  }
  if (/^\d+\.?\d*$/.test(data?.fromYear)) {
    const currentYear = new Date().getFullYear();
    if (parseInt(data?.fromYear, 10) < 1960) {
      return 'From year must be atleast 1960';
    }
    if (parseInt(data?.fromYear, 10) > currentYear) {
      return `From year must not be greater than ${currentYear}`;
    }
  } else {
    return 'This must be a number';
  }
};

const toYearValidation = ({ data }) => {
  if (data?.carDetails === 'Any') {
    return;
  }
  if (/^\d+\.?\d*$/.test(data?.toYear)) {
    const currentYear = new Date().getFullYear();
    if (parseInt(data?.toYear, 10) > currentYear) {
      return `To year must not be greater than ${currentYear}`;
    }
    if (parseInt(data?.toYear, 10) < parseInt(data?.fromYear, 10)) {
      return 'To year must not be less than from year';
    }
  } else {
    return 'This must be a number';
  }
};

const handleSubmit = async (data, navigation, user) => {
  if(!data.email && !data.phoneNumber) {
    Toast.show({
      message: 'Warning',
      description:
        'Please enter either email or phone number',
      type: 'warning',
      position: 'top',
      direction: 'left',
    });
    return;
  }

  // if (someMakesHaveNoModel) {
  //   Toast.show({
  //     message: 'Warning',
  //     description:
  //       'Some Make(s) have no model selected.\n Please select at least one.',
  //     type: 'warning',
  //     position: 'top',
  //     direction: 'left',
  //   });
  // }


  const dataCustomer = {
    "email": data.email,
    "phoneNumber": data.phoneNumber,
    "action": "unsub"
  }
  const result = await invoke({ id: 'addRecordInNotificationsUnsubs', paramValue: { data: dataCustomer } });
  if (result.message) {
    Toast.show({
      message: 'Success',
      description: result.message,
      type: 'success',
      position: 'top',
      direction: 'left',
    });
    user.username ==='superadmin' ? navigation.navigate(ROUTES.NotificationUnsub.name) : navigation.navigate(ROUTES.NotificationUnsubDealer.name);
  }
}
const AddRule1 = (props) => {
  // let isToVisible = false;
  // let isMakeVisible = false;

  const user = getUser();

  return (
    <Form
      type="standard"
      onSubmit={({ data, navigation }) => handleSubmit(data, navigation, user)}
      fieldContainer="topLabel"
      lg={{
        formGroups: [
          // general stuff
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            label: 'NOTIFICATION UNSUBSCRIBE',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid ${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: [
                  {
                    type: 'text',
                    field: 'email',
                    label: 'Customer Email',
                    description:
                      'Add customer email to unsubscribe sms offer',
                    mandatory: true,
                    allowWhiteSpaces: true,
                  },
                  {
                    type: 'number',
                    field: 'phoneNumber',
                    label: 'Phone Number',
                    description:
                      'Add customer phone number to unsubscribe sms offer',
                    mandatory: true,
                  },
                ],
              },
            ],
          },
          // // mileage type
          // {
          //   columnsPerRow: 1,
          //   fieldVariant: 'filled',
          //   label: 'Mileage',
          //   labelStyle: {
          //     ...vars.headings.h8,
          //     color: vars.colors.grey.color2,
          //     textTransform: 'uppercase',
          //   },
          //   groupsContainerStyle: {
          //     borderTop: `1px solid ${vars.colors.grey.color2}`,
          //   },
          //   groups: [
          //     {
          //       columns: [
          //         {
          //           type: 'radioGroup',
          //           field: 'mileageType',
          //           variant: 'filled',
          //           label: 'Mileage',
          //           container: 'topLabel',
          //           options: ['All', 'Enter Manually'],
          //           description:
          //             'Selecting All will bypass the mileage range test | Selecting Enter manually will ask for the mileage range',
          //         },
          //       ],
          //     },
          //   ],
          // },
          // // min , max mileage range
          // {
          //   columnsPerRow: 2,
          //   fieldVariant: 'filled',
          //   groups: [
          //     {
          //       columns: [
          //         {
          //           type: 'text',
          //           field: 'minMileage',
          //           label: 'Min Mileage',
          //           description: 'Minimum mileage value you want to set.',
          //           visible: ({ data = {} }) => data?.mileageType === 'Enter Manually',
          //         },
          //         {
          //           type: 'text',
          //           field: 'maxMileage',
          //           label: 'Max Mileage',
          //           description: 'Maximum mileage value you want to set.',
          //           visible: ({ data = {} }) => data?.mileageType === 'Enter Manually',
          //         },
          //       ],
          //     },
          //   ],
          // },
          // // car details radio
          // {
          //   columnsPerRow: 1,
          //   fieldVariant: 'filled',
          //   label: 'car Details',
          //   labelStyle: {
          //     ...vars.headings.h8,
          //     color: vars.colors.grey.color2,
          //     textTransform: 'uppercase',
          //   },
          //   groupsContainerStyle: {
          //     borderTop: `1px solid ${vars.colors.grey.color2}`,
          //   },
          //   groups: [
          //     {
          //       columns: [
          //         {
          //           render: () => (
          //             <View
          //               style={{
          //                 disply: 'flex',
          //                 flexDirection: 'row',
          //                 alignItems: 'center',
          //               }}
          //             >
          //               {user?.dealer?.bulkCalls === 'Pending' ? (
          //                 <Image
          //                   source={dangerLogo}
          //                   style={{ width: 20, height: 20 }}
          //                 />
          //               ) : null}
          //               <Text
          //                 style={{
          //                   paddingTop: 5,
          //                   color: 'orange',
          //                   marginLeft: 4,
          //                 }}
          //               >
          //                 {user?.dealer?.bulkCalls === 'Pending'
          //                   ? 'Fetch Calls Pending'
          //                   : null}
          //               </Text>
          //             </View>
          //           ),
          //           visible: () => user?.dealer?.bulkCalls === 'Pending',
          //         },
          //         {
          //           type: 'radioGroup',
          //           field: 'carDetails',
          //           variant: 'filled',
          //           label: 'Details Type',
          //           options:
          //             user?.dealer?.bulkCalls === 'Complete'
          //               ? ['Select As Per Data', 'Enter Manually', 'Any']
          //               : ['Enter Manually', 'Any'],
          //           description:
          //             'Selecting "Select As Per Data" will fetch results from the Master Data uploaded along with year range fields that are manually input.<br> Selecting "Enter Manually" allows manual entry for Year, Make and Model.<br> Selecting "Any" will let the rule pull all vehicles.',
          //         },
          //       ],
          //     },
          //   ],
          // },
          // // year range , manual entry
          // {
          //   columnsPerRow: 2,
          //   fieldVariant: 'filled',
          //   groups: [
          //     {
          //       columns: [
          //         {
          //           type: 'text',
          //           field: 'fromYear',
          //           label: 'From',
          //           description: 'Provide a year range',
          //           visible: ({ data = {} }) => (data?.carDetails === 'Select As Per Data'
          //             || data?.carDetails === 'Enter Manually'
          //             ? 1
          //             : 0),
          //         },
          //         {
          //           type: 'text',
          //           field: 'toYear',
          //           label: 'To',
          //           description: 'Provide a year range',
          //           visible: ({ data = {} }) => {
          //             if (/^\d+\.?\d*$/.test(data?.fromYear)) {
          //               const radioCondition = !!(
          //                 data?.carDetails === 'Select As Per Data'
          //                 || data?.carDetails === 'Enter Manually'
          //               );

          //               const currentYear = new Date().getFullYear();
          //               const rangeCondition = parseInt(data?.fromYear, 10) >= 1960
          //                 && parseInt(data?.fromYear, 10) <= currentYear;

          //               if (radioCondition && rangeCondition) {
          //                 isToVisible = true;
          //               } else {
          //                 isToVisible = false;
          //               }
          //             } else {
          //               isToVisible = false;
          //             }
          //             return isToVisible;
          //           },
          //         },
          //         {
          //           type: 'text',
          //           field: 'textMake',
          //           label: 'Enter Make',
          //           description: 'Enter make of vehicle',
          //           visible: ({ data }) => data?.carDetails === 'Enter Manually',
          //         },
          //         {
          //           type: 'text',
          //           field: 'textModel',
          //           label: 'Enter Model',
          //           description: 'Enter model of vehicle',
          //           visible: ({ data }) => data?.carDetails === 'Enter Manually',
          //         },
          //       ],
          //     },
          //   ],
          // },
          // // car type radio
          // {
          //   columnsPerRow: 2,
          //   fieldVariant: 'filled',
          //   groups: [
          //     {
          //       columns: [
          //         multiSearchInput(
          //           {
          //             icon: rescheduleIcon,
          //             field: 'make',
          //             query: 'makersList',
          //             model: 'CarMaker',
          //             idField: '_id',
          //             label: 'Make',
          //             placeholder: 'Select',
          //             searchField: 'name',
          //             suggestionField: 'name',
          //             valueField: 'name',
          //             mandatory: true,
          //             selectAll: true,
          //             description: 'Select make(s) of the vehicle',
          //             visible: ({ data = {} }) => {
          //               const { fromYear, toYear, carDetails } = data;
          //               if (
          //                 fromYear
          //                 && toYear
          //                 && carDetails
          //                 && carDetails === 'Select As Per Data'
          //                 && isToVisible
          //               ) {
          //                 isMakeVisible = true;
          //               } else {
          //                 isMakeVisible = false;
          //               }
          //               return isMakeVisible;
          //             },
          //           },
          //           {
          //             addOnFilter: () => ({
          //               dealer: {
          //                 _id:
          //                   user?.role?.code === 'dealer'
          //                     ? user?.dealer?._id
          //                     : props?.navigation?.state?.params?.item?.madeBy
          //                       ?._id,
          //               },
          //             }),
          //           },
          //         ),

          //         multiSearchInput(
          //           {
          //             icon: rescheduleIcon,
          //             field: 'model',
          //             query: 'carModelList',
          //             model: 'CarModel',
          //             idField: '_id',
          //             label: 'Model',
          //             placeholder: 'Select',
          //             searchField: 'name',
          //             suggestionField: 'name',
          //             valueField: 'name',
          //             mandatory: true,
          //             selectAll: true,
          //             description: 'Select model(s) of vehicle',
          //             visible: ({ data = {} }) => data?.make
          //               && data?.make?.length !== 0
          //               && data?.carDetails === 'Select As Per Data'
          //               && isMakeVisible,
          //           },
          //           {
          //             addOnFilter: ({ data = {} }) => {
          //               const stores = data?.make?.map((store) => store._id);
          //               return { maker: { _id: { $in: stores } } };
          //             },
          //           },
          //         ),
          //       ],
          //     },
          //   ],
          // },
        ],
      }}
      {...props}
    />
  );
};
export default AddRule1;
